import { CalculatedMplusInfo, ICreditInfo, MInstalmentInfo } from '.'
import { makeAutoObservable, toJS } from 'mobx'

import { ICustomerDetails } from 'pages/excursions/customer-details'

import { FormPassengersValues } from 'entities/ticket/models/form-passengers'

interface InstallmentInfo {
  price: string
  quantity: number
}

class MplusStore {
  creditInfo: ICreditInfo | null = null

  passengersFormData: FormPassengersValues | null = null
  excursionsData: ICustomerDetails | null = null

  aviaInstallmentData: InstallmentInfo | null = null

  installmentInfo: CalculatedMplusInfo | null = null

  mInstalmentInfo: MInstalmentInfo | null = null

  constructor() {
    makeAutoObservable(this)
  }

  setPassengersForm(data: FormPassengersValues | null) {
    this.passengersFormData = data
  }

  setInstallmentData(data: InstallmentInfo | null) {
    this.aviaInstallmentData = data
  }

  setExcursionsData(data: ICustomerDetails | null) {
    this.excursionsData = data
  }
  setInstallmentInfo(data: CalculatedMplusInfo | null) {
    this.installmentInfo = data
  }

  setMInstalmentInfo(data: MInstalmentInfo | null) {
    this.mInstalmentInfo = data
  }

  getPassengersForm() {
    return toJS(this.passengersFormData)
  }
  getAviaInstallmentData() {
    return toJS(this.aviaInstallmentData)
  }

  getExcursionsData() {
    return toJS(this.excursionsData)
  }

  getInstallmentInfo() {
    return toJS(this.installmentInfo)
  }

  getMInstalmentInfo() {
    return toJS(this.mInstalmentInfo)
  }

  setCreditInfo(data: ICreditInfo) {
    this.creditInfo = data
  }

  getMplusInfo() {
    return toJS(this.creditInfo)
  }

  removeAviaData() {
    this.passengersFormData = null
  }

  removeExcursionData() {
    this.excursionsData = null
  }
}

export const mplusStore = new MplusStore()
